module.exports = __webpack_public_path__ + "img/RP_Pugio01.41f5cb43.png";